import { Link } from 'react-router-dom';
import { articles, categories } from '../data/articlesData';
import { useState } from 'react';
import imgBuildingSea from '../assets/images/building-sea-view.jpg';
import imgHighrise from '../assets/images/highrise-sea.jpg';
import imgInteriorLiving from '../assets/images/interior-living.jpg';
import imgInteriorBedroom from '../assets/images/interior-bedroom.jpg';
import imgInteriorKitchen from '../assets/images/interior-kitchen.jpg';
import imgSeaBalcony from '../assets/images/sea-view-balcony.jpg';
import imgFacade from '../assets/images/building-facade.jpg';
import imgJerusalemReal from '../assets/images/jerusalem-real.jpg';
import imgJerusalem from '../assets/images/jerusalem.jpg';
import imgConsultation from '../assets/images/consultation.jpg';
import imgContract from '../assets/images/contract.jpg';
import imgCityAerial from '../assets/images/city-aerial.jpg';
import imgTelAvivBeach from '../assets/images/tel-aviv-beach.jpg';
import imgTelAvivModern from '../assets/images/tel-aviv-modern.jpg';
import imgHaifaReal from '../assets/images/haifa-real.jpg';
import imgNetanyaSea from '../assets/images/netanya-sea.jpg';
import imgNegev from '../assets/images/negev-desert.jpg';

const IMG_MAP = {
  'building-sea-view': imgBuildingSea,
  'highrise-sea': imgHighrise,
  'interior-living': imgInteriorLiving,
  'interior-bedroom': imgInteriorBedroom,
  'interior-kitchen': imgInteriorKitchen,
  'sea-view-balcony': imgSeaBalcony,
  'building-facade': imgFacade,
  'jerusalem-real': imgJerusalemReal,
  'jerusalem': imgJerusalem,
  'consultation': imgConsultation,
  'contract': imgContract,
  'city-aerial': imgCityAerial,
  'tel-aviv-beach': imgTelAvivBeach,
  'tel-aviv-modern': imgTelAvivModern,
  'haifa-real': imgHaifaReal,
  'netanya-sea': imgNetanyaSea,
  'negev-desert': imgNegev,
};

export default function Blog() {
  const [activeCategory, setActiveCategory] = useState('all');
  const filtered = activeCategory === 'all' ? articles : articles.filter(a => a.category === activeCategory);

  const filterBtn = (active) => ({
    padding: '5px 14px', borderRadius: 'var(--radius-sm)',
    border: `1.5px solid ${active ? 'var(--color-primary)' : 'var(--color-border)'}`,
    cursor: 'pointer', fontSize: '0.78rem', fontWeight: 600,
    fontFamily: 'var(--font-body)', letterSpacing: '0.04em',
    background: active ? 'var(--color-primary)' : 'var(--color-bg-white)',
    color: active ? '#fafaf8' : 'var(--color-text-muted)', transition: 'all 0.2s',
  });

  return (
    <div className="page-content">
      <div className="container" style={{ maxWidth: 900 }}>
        <span className="gold-tag">Ressources</span>
        <h1>Guide & Articles</h1>
        <p style={{ fontSize: '1.05rem', marginBottom: '2.5rem' }}>
          Analyses de marché, guides pratiques et questions de nos lecteurs — tout ce qu'il faut savoir pour investir en Israël.
        </p>

        <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginBottom: '2.5rem' }}>
          <button style={filterBtn(activeCategory === 'all')} onClick={() => setActiveCategory('all')}>Tous ({articles.length})</button>
          {categories.map(c => (
            <button key={c} style={filterBtn(activeCategory === c)} onClick={() => setActiveCategory(c)}>
              {c} ({articles.filter(a => a.category === c).length})
            </button>
          ))}
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          {filtered.map((article, idx) => {
            const thumb = article.coverImage ? IMG_MAP[article.coverImage] : null;
            const isNew = new Date(article.date) > new Date('2025-01-01');
            return (
              <Link
                key={article.id}
                to={`/blog/${article.slug}`}
                style={{
                  display: 'flex', gap: 0,
                  background: 'var(--color-bg-white)',
                  borderRadius: 'var(--radius-lg)',
                  border: '1px solid var(--color-border)',
                  textDecoration: 'none', color: 'inherit',
                  transition: 'all 0.2s',
                  overflow: 'hidden',
                  boxShadow: 'var(--shadow-sm)',
                }}
                onMouseEnter={e => { e.currentTarget.style.boxShadow = 'var(--shadow-md)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                onMouseLeave={e => { e.currentTarget.style.boxShadow = 'var(--shadow-sm)'; e.currentTarget.style.transform = 'translateY(0)'; }}
              >
                {/* Thumbnail */}
                {thumb && (
                  <div style={{
                    width: 220, minWidth: 220, height: 'auto',
                    backgroundImage: `url(${thumb})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    position: 'relative',
                    flexShrink: 0,
                  }}>
                    {isNew && (
                      <span style={{
                        position: 'absolute', top: 10, left: 10,
                        background: 'var(--color-accent)', color: '#0d1f3c',
                        fontSize: '0.65rem', fontWeight: 800, letterSpacing: '0.1em',
                        textTransform: 'uppercase', padding: '3px 8px',
                        borderRadius: '3px',
                      }}>Nouveau</span>
                    )}
                  </div>
                )}

                {/* Content */}
                <div style={{ flex: 1, padding: '1.5rem 1.75rem', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', minHeight: 160 }}>
                  <div>
                    <div style={{ display: 'flex', gap: '0.625rem', alignItems: 'center', marginBottom: '0.75rem', flexWrap: 'wrap' }}>
                      <span className="badge badge-blue">{article.category}</span>
                      <span style={{ fontSize: '0.72rem', color: 'var(--color-text-muted)' }}>
                        {new Date(article.date).toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
                      </span>
                      <span style={{ fontSize: '0.72rem', color: 'var(--color-text-muted)' }}>{article.readTime} min</span>
                    </div>
                    <h3 style={{ margin: '0 0 0.5rem', fontSize: '1.1rem', lineHeight: 1.35, color: 'var(--color-primary)' }}>{article.title}</h3>
                    <p style={{ margin: 0, fontSize: '0.875rem', lineHeight: 1.65, color: 'var(--color-text-muted)' }}>
                      {article.excerpt.length > 120 ? article.excerpt.slice(0, 120) + '…' : article.excerpt}
                    </p>
                  </div>
                  <div style={{ marginTop: '1rem' }}>
                    <span style={{ fontSize: '0.78rem', fontWeight: 700, color: 'var(--color-accent)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                      Lire l'article →
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
